module.exports = __webpack_public_path__ + "img/2010 winteressen 028.55605b5a.jpg";